import { Link } from '@inertiajs/react';
import { ServicesCatalog } from '@/data/services';
import { trackUmamiEvent } from '@/lib/analytics';

/**
 * Numbered hairline services list for Home, matching the mockup's `.svc`.
 * Each row links to `/services` and shows the number, title, and short
 * blurb, with a trailing arrow.
 */
export const ServiceList = () => (
  <div className="border-line border-t">
    {ServicesCatalog.map(({ title, blurb, slug }, index) => (
      <Link
        key={title}
        href="/services"
        onClick={() => trackUmamiEvent('service_click', { service: slug })}
        className="border-line-soft hover:bg-surface grid grid-cols-[38px_1fr_20px] items-baseline gap-3.5 border-b px-0.5 py-5 transition-colors duration-150 md:grid-cols-[56px_1fr_24px] md:gap-6.5 md:px-1 md:py-6.5"
      >
        <span className="font-display text-primary text-[15px] [font-variant-numeric:tabular-nums]">
          {String(index + 1).padStart(2, '0')}
        </span>
        <div>
          <h3 className="text-[clamp(20px,5.5vw,26px)]">{title}</h3>
          <div className="text-ink-soft mt-[5px] max-w-[54ch] text-sm">{blurb}</div>
        </div>
        <span className="text-accent self-center text-lg" aria-hidden="true">
          →
        </span>
      </Link>
    ))}
  </div>
);
